import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	CREATE_SPIN_GAME_MESSAGE_REQUEST,
	CREATE_SPIN_GAME_MESSAGE_SUCCESS,
	CREATE_SPIN_GAME_MESSAGE_FAIL,
	RESET_DELETE_SPIN_GAME_MESSAGE,
	FETCH_SPIN_GAME_MESSAGES_REQUEST,
	FETCH_SPIN_GAME_MESSAGES_SUCCESS,
	FETCH_SPIN_GAME_MESSAGES_FAIL,
	UPDATE_SPIN_GAME_MESSAGE_REQUEST,
	UPDATE_SPIN_GAME_MESSAGE_SUCCESS,
	UPDATE_SPIN_GAME_MESSAGE_FAIL,
	DELETE_SPIN_GAME_MESSAGE_REQUEST,
	DELETE_SPIN_GAME_MESSAGE_SUCCESS,
	DELETE_SPIN_GAME_MESSAGE_FAIL,
	FETCH_SPIN_GAME_MESSAGE_REQUEST,
	FETCH_SPIN_GAME_MESSAGE_SUCCESS,
	FETCH_SPIN_GAME_MESSAGE_FAIL,
} from "../constants/spinTheWheelGameMessage";

const createSpinGameMessage = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: CREATE_SPIN_GAME_MESSAGE_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/game-messages", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchSpinGameMessages({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_SPIN_GAME_MESSAGE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_SPIN_GAME_MESSAGE_FAIL, payload: errorMessage });
	}
};

const fetchSpinGameMessages = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SPIN_GAME_MESSAGES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/game-messages", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SPIN_GAME_MESSAGES_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SPIN_GAME_MESSAGES_FAIL, payload: errorMessage });
	}
};

const resetDeleteStatusSpinGameMessage = () => async (dispatch) => {
	dispatch({ type: RESET_DELETE_SPIN_GAME_MESSAGE });
};

const updateSpinGameMessage = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_SPIN_GAME_MESSAGE_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/game-messages/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_SPIN_GAME_MESSAGE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_SPIN_GAME_MESSAGE_FAIL, payload: errorMessage });
	}
};

const deleteSpinGameMessage = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_SPIN_GAME_MESSAGE_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/game-messages/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_SPIN_GAME_MESSAGE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_SPIN_GAME_MESSAGE_FAIL, payload: errorMessage });
	}
};

const fetchSpinGameMessage = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SPIN_GAME_MESSAGE_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/game-messages/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		dispatch({ type: FETCH_SPIN_GAME_MESSAGE_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SPIN_GAME_MESSAGE_FAIL, payload: errorMessage });
	}
};

export {
	createSpinGameMessage,
	resetDeleteStatusSpinGameMessage,
	fetchSpinGameMessages,
	updateSpinGameMessage,
	deleteSpinGameMessage,
	fetchSpinGameMessage,
};
